import { useAppDispatch, userLogin } from '@core/core/store'
import type { Messenger } from 'common/messenger'
import { messengerRef } from 'common/messenger'
import { useEffect, useLayoutEffect } from 'react'

export const useMessenger = (messenger: Messenger) => {
  const dispatch = useAppDispatch()

  useLayoutEffect(() => {
    messengerRef.current = messenger

    return () => {
      messengerRef.current = null
    }
  }, [messenger])

  useEffect(() => {
    const unsubscribe = messengerRef.current?.subscribe('userLoggedIn', () => {
      dispatch(userLogin())
    })

    return unsubscribe
  }, [dispatch])
}
